export enum LeftMenuItem {
  EXPERIMENTAL_organizationFeatures = "experimentalOrganizationFeatures",
  adminLocations = "adminLocations",
  adminOrganizations = "adminOrganizations",
  adminFunctionManagement = "adminFunctionManagement",
  adminInternalTools = "adminInternalTools",
  adminDeleteGoogleLink = "adminDeleteGoogleLink",
  adminMassSendEmails = "adminMassSendEmails",
  adminReturnToAdminMain = "adminReturnToAdminMain",
  adminAccountManagement = "adminAccountManagement",
  adminFindUserAccount = "adminFindUserAccount",
  adminInternalLabelsManagement = "adminInternalLabelsManagement",
  adminErrorLogsManagement = "adminErrorLogsManagement",
  orgDashboard = "orgDashboard",
  orgMassPost = "orgMassPost",
  orgAnalysisCollections = "orgAnalysisCollections",
  orgRecommendations = "orgRecommendations",
  orgRecMessages = "orgRecMessages",
  orgTools = "orgTools",
  facilityList = "facilityList",
  locationActivity = "locationActivity",
  accountSettings = "accountSettings",
  manageLocations = "manageLocations",
  customizedReviewsAnalysis = "CustomizedReviewsAnalysis",
  adminLocationAlerts = "adminLocationAlerts",
  dataDownload = "dataDownload",
  orgProject = "orgProject",
  facilityReports = "facilityReports",
}

export const ADMIN_MENU_ITEMS: (LeftMenuItem | undefined)[] = [
  LeftMenuItem.adminLocations,
  LeftMenuItem.locationActivity,
  LeftMenuItem.adminOrganizations,
  LeftMenuItem.adminFunctionManagement,
  LeftMenuItem.adminInternalTools,
  LeftMenuItem.adminFindUserAccount,
  LeftMenuItem.adminDeleteGoogleLink,
  LeftMenuItem.adminMassSendEmails,
  LeftMenuItem.customizedReviewsAnalysis,
  LeftMenuItem.facilityReports,
  LeftMenuItem.adminInternalLabelsManagement,
  LeftMenuItem.adminLocationAlerts,
  LeftMenuItem.adminErrorLogsManagement,
];

export const ORG_ADMIN_MENU_ITEMS: (LeftMenuItem | undefined)[] = [
  LeftMenuItem.orgDashboard,
  LeftMenuItem.orgProject,
  LeftMenuItem.orgMassPost,
  LeftMenuItem.facilityList,
  LeftMenuItem.locationActivity,
  LeftMenuItem.orgAnalysisCollections,
  LeftMenuItem.orgRecommendations,
  LeftMenuItem.orgRecMessages,
  LeftMenuItem.orgTools,
  LeftMenuItem.accountSettings,
  LeftMenuItem.manageLocations,
  LeftMenuItem.EXPERIMENTAL_organizationFeatures,
];

export const ADMIN_AS_ORG_ADMIN_MENU_ITEMS: LeftMenuItem[] = [
  LeftMenuItem.orgDashboard,
  LeftMenuItem.orgProject,
  LeftMenuItem.orgMassPost,
  LeftMenuItem.orgAnalysisCollections,
  LeftMenuItem.facilityList,
  LeftMenuItem.orgRecommendations,
  LeftMenuItem.orgRecMessages,
  LeftMenuItem.orgTools,
  LeftMenuItem.adminAccountManagement,
  LeftMenuItem.dataDownload,
  LeftMenuItem.EXPERIMENTAL_organizationFeatures,
  LeftMenuItem.adminReturnToAdminMain,
];

export const LOC_ADMIN_MENU_ITEMS: (LeftMenuItem | undefined)[] = [
  LeftMenuItem.facilityList,
  LeftMenuItem.locationActivity,
  LeftMenuItem.accountSettings,
  LeftMenuItem.manageLocations,
];
